module.exports = __webpack_public_path__ + "static/media/service-details1.5585125f.jpg";